<template>
  <full-container>
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form :inline="true" :model="queryParams" size="small" class="search-form">
        <el-form-item>
          <el-select v-model="queryParams.mode" clearable placeholder="客户类型">
            <el-option :value="0" label="一般客户" />
            <el-option :value="1" label="经销商" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.keyWord" placeholder="名称关键字" clearable />
        </el-form-item>
        <el-button type="primary" size="small" @click="onSearch">查询</el-button>
      </el-form>
      <el-button v-action="'/api/System/Customer/Submit'" size="small" type="primary" icon="el-icon-plus" @click="openForm()">新增</el-button>
    </div>

    <!--表格-->
    <el-table v-loading="loading" ref="tb" :data="datalist.Items" height="100%">
      <el-table-column prop="ModeText" label="客户类型" min-width="100" />
      <el-table-column label="客户名称" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-link @click="$router.push({ path: row.Id })">{{ row.Name }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="Code" label="统一社会信用代码" min-width="180" />
      <el-table-column prop="Address" label="联系地址" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Linkman" label="联系人" min-width="100" />
      <el-table-column prop="Linktel" label="联系电话" min-width="120" show-overflow-tooltip />
      <el-table-column label="创建时间" width="120">
        <span slot-scope="scope">
          {{ $utils.common.parseTime(scope.row.CreateTime) }}
        </span>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="{ row }">
          <el-link v-action="'/api/System/Customer/Submit'" type="primary" icon="el-icon-edit" @click="openForm(row)">修改</el-link>
          <el-link v-action="'/api/System/Customer/Delete'" type="info" icon="el-icon-delete" @click="onDelete(row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onPager" />
  </full-container>
</template>



<script>
import formpage from './form.vue'
export default {
  data () {
    return {
      loading: false,
      datalist: [],
      queryParams: {
        index: 1,
        size: 20,
      },
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.organize.customer.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //编辑
    openForm (row = {}) {
      this.$layer.iframe({
        title: '客户编辑',
        area: ['480px', 'auto'],
        content: {
          content: formpage,
          parent: this,
          data: {
            _detail: row,
            callback: () => {
              this.loadData()
            }
          }
        }
      })
    },
    //删除
    onDelete (row) {
      this.$confirm("此操作将永久删除数据不可恢复, 是否继续?", `删除${row.Name}`, {
        center: true,
      }).then(() => {
        this.$apis.organize.customer.delete({ id: row.Id }).then((res) => {
          this.loadData()
          this.$message({
            message: res || "执行成功！",
            type: "success",
          })
        })
      })
    }
  }
}
</script>
